// TODO: Polyfill or alter before release
export function getParamFromWindow(paramName) {
    var windowSearchParams = new URLSearchParams(window.location.search);
    return windowSearchParams.get(paramName);
}
//# sourceMappingURL=getParamFromWindow.js.map